<template>
  <div
    v-if="$vuetify.breakpoint.width < 768"
    v-click-outside="emitOutsideMobile"
    class="mobile-bar align-items-center d-flex d-md-none justify-content-between pl-3"
  >
    <div
      style="cursor : pointer"
      @click="toggleMenu"
    >
      <button class="btn-open-menu" />
    </div>
    <StudyNowButton 
      v-if="user.is_student"
      class="mr-3"
    />
  </div>
</template>

<script>
import StudyNowButton from '@/student/components/StudyNowButton.vue';
export default {
  components: { StudyNowButton },
  props: {
    toggleMenu: {
      type: Function,
      required: true
    }
  },
  computed:{
    user(){
      return this.$store.state.auth.user
    }
  },
  methods: {
    emitOutsideMobile() {
     this.$root.$emit("outsideMobile");
    }
  },
}
</script>

<style lang="scss">
  .mobile-bar {
    height: 56px;
    width: 100%;
    background-color: #060181;
    border-top: 1px solid #707070;
    bottom: 0;
    position: fixed;
    left: 0;
    z-index: 5;

    @media (min-width: 768px) {
      display: none;
    }
  }

  .btn-open-menu {
    position: relative;
    display: inline-block;
    outline: none !important;

    &,
    &::before,
    &::after {
      width: 24px;
      height: 4px;
      background: #fff;
      transition: all .3s;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 0;
    }

    &::before {
      top: -8px;
    }

    &::after {
      top: 8px;
    }
  }
</style>
